import { SharedBusinessEntity } from '../shared/_config/api/shared-business-entity';
import { ExtRelSaveQueryI } from './rel-save/rel-save.query.ext';
import { RelSaveResponseI } from './rel-save/rel-save.query.result.int';
import { ApiSharedMethod } from './api-methods.shared';
import { MapRelSave } from './rel-save/rel-save.map';

export class ApiRelMethod<T1, T2> extends ApiSharedMethod<T1, T2> {
    static readonly relSave = new ApiSharedMethod<RelSaveResponseI, ExtRelSaveQueryI>(
        2,
        SharedBusinessEntity.container,
        `relocateContainer`,
        MapRelSave.mapResponse,
        MapRelSave.mapRequest,
    );
}
